import { useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'

import { canAccessResignationMangementTab, canAccessResignationPage } from 'helpers/resignationsHelper'

export default function ResignationPermissible({ children, errorPageComponent = null }) {
  const currentUser = useSelector(
    (state) => state.users.allUserProfiles?.[state.reduxTokenAuth?.currentUser?.attributes?.id]
  )

  const permissions = useSelector((state) => state.permissions.userPermissions)

  const { pathname } = useLocation()
  const isResignationManagementPath = pathname.includes('resignations/management')

  if (isResignationManagementPath && !canAccessResignationMangementTab(currentUser, permissions)) {
    return errorPageComponent
  } else if (canAccessResignationPage(currentUser, permissions)) {
    return children
  }
  return errorPageComponent
}
